import React, { createContext, useContext, useState } from 'react';

import { ShortcutContext } from './types';

interface ShortcutsContextValue {
  currentContext: ShortcutContext;
  setCurrentContext: (context: ShortcutContext) => void;
  selectedEmailIndex: number;
  setSelectedEmailIndex: (index: number) => void;
  isShortcutsEnabled: boolean;
  setIsShortcutsEnabled: (enabled: boolean) => void;
}

const ShortcutsContext = createContext<ShortcutsContextValue | undefined>(
  undefined,
);

interface ShortcutsProviderProps {
  children: React.ReactNode;
}

export function ShortcutsProvider({ children }: ShortcutsProviderProps) {
  const [currentContext, setCurrentContext] = useState<ShortcutContext>(
    ShortcutContext.GLOBAL,
  );
  const [selectedEmailIndex, setSelectedEmailIndex] = useState<number>(-1);
  const [isShortcutsEnabled, setIsShortcutsEnabled] = useState<boolean>(true);

  const contextValue: ShortcutsContextValue = {
    currentContext,
    setCurrentContext,
    selectedEmailIndex,
    setSelectedEmailIndex,
    isShortcutsEnabled,
    setIsShortcutsEnabled,
  };

  return (
    <ShortcutsContext.Provider value={contextValue}>
      {children}
    </ShortcutsContext.Provider>
  );
}

export function useShortcutsContext(): ShortcutsContextValue {
  const context = useContext(ShortcutsContext);
  if (context === undefined) {
    throw new Error(
      'useShortcutsContext must be used within a ShortcutsProvider',
    );
  }
  return context;
}
